import { dateCompare, isNullOrWhitespace, strCompareLowerCase } from "@common/Common";
import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue';
import { guid } from "@common/Guid";
import { ICommandStatus } from "@cqrs/cqrs";
import CriteriaHierarchyQueries from "@Criteria/Hierarchies/Domain/queries-vue-component";
import { CriteriaHierarchyDependenciesReadModel } from "@Criteria/Hierarchies/Domain/readmodels";
import { IEvaluationCommand } from '@Evaluation/cqrs';
import { EvalModelBuilderViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelBuilder";
import EvalModelBuilder from '@Evaluation/EvaluationModels/Components/EvalModelBuilder.vue';
import { EvalModelClonerViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelCloner";
import EvalModelCloner from '@Evaluation/EvaluationModels/Components/EvalModelCloner.vue';
import { EvalModelDeleterViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelDeleter";
import EvalModelDeleter from '@Evaluation/EvaluationModels/Components/EvalModelDeleter.vue';
import { EvalModelEditorViewModel } from "@Evaluation/EvaluationModels/Components/EvalModelEditor";
import EvalModelEditor from '@Evaluation/EvaluationModels/Components/EvalModelEditor.vue';
import { CloneEvalModelCommandV1, CreateEvalModelCommandV1, DeleteEvalModelCommandV1, RenameGoalCommandV1 } from "@Evaluation/EvaluationModels/Domain/commands-core";
import EvalModelsCommands from "@Evaluation/EvaluationModels/Domain/commands-vue-component";
import EvalModelsQueries from "@Evaluation/EvaluationModels/Domain/queries-vue-component";
import { EvalModelReadModel, EvalModelsPageReadModel } from "@Evaluation/EvaluationModels/Domain/readmodels";
import moment from "moment";
import Component, { mixins } from 'vue-class-component';


@Component({
    components: { PortfolioNavigation, EvalModelDeleter, EvalModelEditor, EvalModelBuilder, EvalModelCloner }
})
export default class EvalModelsPage extends mixins(EvalModelsQueries, EvalModelsCommands, CriteriaHierarchyQueries)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId) }
    get projectId(): number { return Number.parseInt(this.$route.params.projectId) }

    Initialized: boolean = false;

    SearchPhrase: string = null;
    OrderBy: string = "created";
    OrderByDescending: boolean = true;
    creating: boolean = false;
    Projects: GoalVM[] = null;
    evalModelDeleter = new EvalModelDeleterViewModel();
    evalModelEditor = new EvalModelEditorViewModel();
    evalModelBuilder = new EvalModelBuilderViewModel();
    evalModelCloner = new EvalModelClonerViewModel();


    get ProjectsView(): GoalVM[]
    {
        if (this.Projects == null)
        {
            return null;
        }

        let view = new Array(...this.Projects);

        if (!isNullOrWhitespace(this.SearchPhrase))
        {
            view = this.Projects.filter(o => o.Name.toLowerCase().indexOf(this.SearchPhrase.toLowerCase()) >= 0);
        }

        if (this.OrderBy === "name")
        {
            view = view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }
        else if (this.OrderBy === "created")
        {
            view = view.sort((a, b) => dateCompare(a.Created, b.Created));
        }

        if (this.OrderByDescending === true)
        {
            view = view.reverse();
        }

        return view;
    }

    formatDate(date: string | null)
    {
        if (date == null) return null;
        return moment(date).format('MMM D, YYYY')
    }

    formatTime(date: string | null)
    {
        if (date == null) return null;
        return moment(date).format('LT');
    }


    showGoalCreator()
    {
        this.evalModelBuilder.show();
    }

    showGoalEditor(vm: GoalVM)
    {
        this.evalModelEditor.show(vm.EvalModelId, vm.Name);
    }

    showGoalCloner(vm: GoalVM)
    {
        this.evalModelCloner.show(vm.EvalModelId, vm.Name);
    }

    showGoalDeleter(vm: GoalVM)
    {
        this.evalModelDeleter.show(vm.EvalModelId, vm.Name);
        this.runCriteriaHierarchyDependenciesQueryV1(this.workspaceId, vm.CriteriaHierarchyId);
    }


    OrderByNameCommand()
    {
        if (this.OrderBy === 'name')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = false;
            this.OrderBy = 'name';
        }
    }

    OrderByCreatedCommand()
    {
        if (this.OrderBy === 'created')
        {
            this.OrderByDescending = !this.OrderByDescending;
        }
        else
        {
            this.OrderByDescending = true;
            this.OrderBy = 'created';
        }
    }

    handleCreateEvalModelCommand(goalName: string)
    {
        this.invokeCreateEvalModelCommandV1(this.workspaceId, this.projectId, goalName, `${guid()}.Default`);
    }

    handleRenameGoalCommand(evalModelId: number, goalName: string)
    {
        this.invokeRenameGoalCommandV1(this.workspaceId, evalModelId, goalName);
    }

    handleCloneEvalModelCommand(sourceId: number, cloneName: string)
    {
        this.invokeCloneEvalModelCommandV1(this.workspaceId, sourceId, cloneName, `${guid()}.Default`);
    }

    handleDeleteEvalModelCommand(evalModelId: number)
    {
        this.invokeDeleteEvalModelCommandV1(this.workspaceId, evalModelId);
    }


    mounted()
    {
        document.title = "Goals | TransparentChoice";
        this.runEvalModelsPageQueryV1(this.workspaceId, this.projectId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "EvalModelsPageReadModel")
        {
            const rm = model as EvalModelsPageReadModel;

            this.Projects = rm.Goals.map(a => new GoalVM(a));

            this.Initialized = true;
        }
        else if (modelName === "EvalModelReadModel")
        {
            const rm = model as EvalModelReadModel;

            const curr = this.Projects.find(a => a.EvalModelId === rm.EvalModelId);

            if (curr)
            {
                curr.Name = rm.Goal;
            }
            else if (this.creating)
            {
                this.creating = false;
                window.location.href = rm.Url;
            }
            else
            {
                const vm = new GoalVM(rm);
                this.Projects.push(vm);
            }
        }
        else if (modelName === "CriteriaHierarchyDependenciesReadModel")
        {
            const rm = model as CriteriaHierarchyDependenciesReadModel;
            this.evalModelDeleter.setData(rm);
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
    {
        if (CreateEvalModelCommandV1.matchType(cmd))
        {
            const evalModelName = correlationId;
            this.creating = true;
            this.runEvalModelByNameQueryV1(this.workspaceId, this.projectId, evalModelName);

            this.evalModelBuilder.close();
        }
        else if (CloneEvalModelCommandV1.matchType(cmd))
        {
            const evalModelName = correlationId;
            this.runEvalModelByNameQueryV1(this.workspaceId, this.projectId, evalModelName);

            this.evalModelCloner.close();
        }
        else if (DeleteEvalModelCommandV1.matchType(cmd))
        {
            const evalModelId = Number.parseInt(correlationId);
            this.Projects.remove(this.Projects.find(a => a.EvalModelId === evalModelId));

            this.evalModelDeleter.close();
        }
        else if (RenameGoalCommandV1.matchType(cmd))
        {
            const evalModelId = Number.parseInt(correlationId);
            this.runEvalModelByIdQueryV1(this.workspaceId, evalModelId);

            this.evalModelEditor.close();
        }

    }

    onCommandFailed(status: ICommandStatus)
    {
        if (CreateEvalModelCommandV1.matchType(status.Command))
        {
            this.evalModelBuilder.displayValidationErrors(status.ValidationErrors);            
        }
        else if (RenameGoalCommandV1.matchType(status.Command))
        {
            this.evalModelEditor.displayValidationErrors(status.ValidationErrors);
        }
        else if (CloneEvalModelCommandV1.matchType(status.Command))
        {
            this.evalModelCloner.displayValidationErrors(status.ValidationErrors);
        }
    }
}

class GoalVM
{
    EvalModelId: number;
    CriteriaHierarchyId: number;
    Name: string = null;
    Created: Date;
    CreatedDateStr: string;
    CreatedTimeStr: string;
    Url: string = null;

    constructor(rm: EvalModelReadModel)
    {
        this.EvalModelId = rm.EvalModelId;
        this.CriteriaHierarchyId = rm.CriteriaHierarchyId;
        this.Name = rm.Goal;
        this.Url = rm.Url;

        this.Created = new Date(rm.Created);
        this.CreatedDateStr = moment(this.Created).format('MMM D, YYYY');
        this.CreatedTimeStr = moment(this.Created).format('LT');
    }
}